import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentModalOpen = (state: StateScheme) => {
    return state.payment.isPaymentModalOpen
}
